import {Contact} from '../contact.model';

export class InvoiceContact extends Contact {
}
